// Create this new file: src/pages/CustomerProfile.js

import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ProfilePage from '../components/ProfilePage';
import { Button, Box } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

const CustomerProfile = () => {
  const { id } = useParams(); // Get customer ID from URL
  const navigate = useNavigate();

  return (
    <Box>
      {/* Back button to return to customers list */}
      <Box mb={2}>
        <Button
          startIcon={<ArrowBack />}
          onClick={() => navigate('/erp/accounts/customers')}
          variant="outlined"
          size="small"
        >
          Back to Customers
        </Button>
      </Box>
      
      {/* Profile component with the customer ID */}
      <ProfilePage 
        entityType="customer" 
        entityId={parseInt(id)} // Pass the ID from URL
      />
    </Box>
  );
};

export default CustomerProfile;